<script lang="ts">
	import { onMount } from 'svelte';
	import { fly } from 'svelte/transition';
	import { clickOutside } from './actions/clickOutside';
	import { toastMessage } from './stores/toast';

	const hide = () => {
		$toastMessage = '';
	};
	onMount(() => {
		const timeout = setTimeout(() => {
			hide();
		}, 5000);

		return () => {
			clearTimeout(timeout);
		};
	});
</script>

<p
	transition:fly={{ y: 10, duration: 100 }}
	aria-live="polite"
	class="fixed bottom-0 left-0 z-10 flex w-full items-center justify-center border-t p-4 bg-black text-white"
	use:clickOutside={{
		callback: hide,
	}}
>
	{$toastMessage}
</p>
